<template>
  <div id="app">
    <b-navbar toggleable="lg" type="dark" variant="dark">
    <b-navbar-brand href="#">iRidi Assistant <Region /></b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <!-- <b-navbar-nav>
        <b-nav-item href="#">Link</b-nav-item>
        <b-nav-item href="#" disabled>Disabled</b-nav-item>
      </b-navbar-nav> -->

      <!-- Right aligned nav items -->

      <b-navbar-nav class="ml-auto">
        <!-- <b-nav-form>
          <b-form-input size="sm" class="mr-sm-2" placeholder="Search"></b-form-input>
          <b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>
        </b-nav-form> -->

        <b-nav-item-dropdown v-if="$root.$data.state.selectedLang" :text="$root.$data.state.selectedLang.title" right>
          <b-dropdown-item
          v-for="lang in langs"
          @click="selectLangLocal(lang.code)"
          :key="lang.code"
          >{{lang.title}}</b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item right v-if="authorized" @click="logout">{{$t('logout')}}</b-nav-item>
        <!-- <b-nav-item  >
          <p style="color: white">{{curlink}}</p>
        </b-nav-item> -->
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
    <b-container>
      <router-view/>
    </b-container>
  <b-modal v-model="$confirm.enable" @ok="$confirm.ok">{{$confirm.title}}</b-modal>
  </div>

</template>
<script>
import Region from './components/Region.vue'
import { supportedLocales } from './i18n'

export default {
  data() {
    return {
      langs: supportedLocales(),
      selectedLang: null,
    }
  },
  components: { Region },
  watch: {
    $route(to) {
      console.log(to.meta.title)
      document.title = to.meta.title || 'i3 KNX'
    },
  },
  methods: {
    selectLangLocal(lang) {
      this.$root.$data.selectLang(lang, this)
    },
    // selectLang(langCode = null) {
    //   if (langCode == null) {
    //     langCode = localStorage.getItem('locale')
    //     if (!langCode && this.$i18n.locale) {
    //       langCode = this.$i18n.locale
    //     }
    //   }
    //   const lang = this.langs.find(l => l.code === langCode) || { code: 'en', title: 'English' }
    //   this.selectedLang = lang
    //   this.$i18n.locale = lang.code
    //   localStorage.setItem('locale', lang.code)
    // },
    logout() {
      localStorage.removeItem('cross_region_auth')
      document.location.reload()
    },
  },
  computed: {
    curlink() {
      return window.location.href
    },
    authorized() {
      return (
        this.$root.$data.state.auth
        && this.$root.$data.state.auth.token
        && this.$root.$data.state.auth.expTokenJsTimestamp
          > Date.now()
      )
    },
  },
  mounted() {
    // eslint-disable-next-line func-names
    this.$root.$data.selectLang(null, this)
    this.$nextTick(function tick() {
      if (this.$route && this.$route.meta) {
        document.title = this.$route.meta.title || 'i3 KNX'
      }
    })
  },
}
</script>

<style lang="scss">
#app {
  // font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
